// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"ButtonArrow_root__Qzv5O","button":"ButtonArrow_button__wGnIq","icon":"ButtonArrow_icon__WuApJ"};